import {Injectable} from '@angular/core';
import {SmmService} from './smm.service';

@Injectable()
export class SmmCommentService {

  constructor(private smmService: SmmService) {
  }

  public searchComments(body) {
    console.log(JSON.stringify(body));
    return this.smmService.getComments(body);
  }
  
  public replyComment(body) {
    // console.log(JSON.stringify(body));
    return this.smmService.replyComment(body);
  }


}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/smm-comment.service.ts